import React, { useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { useNavigate } from "react-router-dom";
import { Column } from "primereact/column";
import { Postpaid } from "../../../../../../utility";
import { ProgressSpinner } from "primereact/progressspinner";
import CommonLoaderBlue from "../../../billingModel/billingmodel_configurations/Loaders/components/Loader/LoaderBlue";
import { OverlayPanel } from "primereact/overlaypanel";
export default function DisplayAdvanceSearchApiResponse({
  isLoading,
  searchData,
  setSearchBy,
}) {
  const navigate = useNavigate();

  const userData = JSON.parse(localStorage.getItem("userData"));
  const role = userData?.role?.role;
  const [overlayContent, setOverlayContent] = useState("");
  const statusOverlayRef = useRef(null);

  const [selectedRows, setSelectedRows] = useState([]);
  const handleEnrollmentIdClick = (rowData) => {
    setSearchBy(null);
    navigate("/customer-profile", { state: { selectedId: rowData._id } });
    localStorage.setItem("selectedId", JSON.stringify(rowData._id));
  };
  return (
    <div className="prepaidall">
      <div className="flex w-full flex-column justify-content-start h-4">
        <div className="prepaidsimslogo">
          <span>
            <Postpaid />
          </span>
          <h6>Enrollment Lookup</h6>
        </div>
        <h3 className="heading" style={{ marginTop: ".6rem" }}>
          Enrollment Records
        </h3>
        <p className="para" style={{ marginTop: "1.2rem" }}>
          Explore enrollment records from across the system, filtered by your
          search criteria.
        </p>
      </div>

      <div
        className={
          role === "Admin" ? "allenrollmenttableadmin" : "allenrollmenttable"
        }
        style={{ marginTop: "2.4rem" }}
      >
        {false ? (
          <ProgressSpinner className="flex flex-wrap justify-content-center flex-row mt-4" />
        ) : null}

        <DataTable
          value={searchData.data}
          selection={selectedRows}
          onSelectionChange={
            role !== "Admin" ? null : (e) => setSelectedRows(e.value)
          }
          size="small"
          stripedRows
          emptyMessage={
            isLoading ? (
              <div
                style={{ width: "98.4rem" }}
                className="flex p-2 flex-wrap flex-row justify-content-center align-items-center "
              >
                <CommonLoaderBlue customSize={14} />
              </div>
            ) : (
              ""
            )
          }
          onRowClick={(e) => handleEnrollmentIdClick(e.data)}
          style={{ fontFamily: "Inter", fontSize: "14.4rem" }}
        >
          <Column
            selectionMode="multiple"
            style={{
              pointerEvents: role !== "Admin" ? "none" : "auto",
              opacity: role !== "Admin" ? 0.5 : 1,
            }}
          />
          <Column header="Id" field="enrollmentId"></Column>
          <Column
            header="Link Acc"
            body={(rowData) => {
              return (
                <p className={rowData?.linkedAccount ? "yes" : "no"}>
                  {rowData?.linkedAccount ? "Yes" : "No"}
                </p>
              );
            }}
          />
          <Column header="Name" field="name"></Column>
          <Column field="contact" header="Contact" />
          <Column
            header="Status"
            field="status"
            body={(rowData) => (
              <span
                style={{
                  color:
                    rowData?.status === "prospect"
                      ? "#4A90E2"
                      : rowData?.status === "cancelled"
                        ? "#95A5A6"
                        : rowData?.status === "active"
                          ? "#27AE60"
                          : rowData?.status === "disconnected"
                            ? "#B3261E"
                            : rowData?.status === "inactive"
                              ? "#B3261E"
                              : rowData?.status === "suspended"
                                ? "#F39C12"
                                : "",
                  fontSize: "1.4rem",
                  textTransform: "capitalize",
                }}
              >
                {rowData?.status}
              </span>
            )}
          />
          {role === "Admin" && (
            <Column
              field="createdBy.name"
              header="Created By"
              body={(rowData) => (
                <>
                  <p
                    onMouseEnter={(e) => {
                      if (rowData?.createdBy?.name?.length > 11) {
                        setOverlayContent(rowData?.createdBy?.name);
                        statusOverlayRef.current.show(e);
                      }
                    }}
                    onMouseLeave={() => statusOverlayRef.current.hide()}
                  >
                    {rowData?.createdBy?.name?.length > 11
                      ? rowData?.createdBy?.name?.substring(0, 8) + "..."
                      : rowData.createdBy?.name?.length === 0
                        ? "NIL"
                        : rowData?.createdBy?.name}
                  </p>
                  <OverlayPanel ref={statusOverlayRef}>
                    <div style={{ padding: "0.5rem 1rem" }}>
                      <p
                        style={{
                          fontWeight: 400,
                          fontSize: "1.4rem",
                          overflow: "hidden",
                          border: "none",
                          margin: "0rem",
                          lineHeight: "1.8rem",
                          color: "#72728f",
                        }}
                      >
                        {" "}
                        {overlayContent}
                      </p>
                    </div>
                  </OverlayPanel>
                </>
              )}
            />
          )}
          <Column field="createdDate" header="Date" />
        </DataTable>
      </div>
    </div>
  );
}
